module.exports = __webpack_public_path__ + "img/03_Arena.dd990d6a.jpg";